import React from "react";
import PropTypes from "prop-types";
import {apiPost, apiRequest} from "../../utils/request";
import ReactTable from "react-table";
import {Aux, IsNullOrUndefined} from "../../constants";
import moment from "moment";
import {Button, Collapse, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter} from "reactstrap";
import {toastr} from "react-redux-toastr";
import {some} from 'lodash';
import QrReader from "react-qr-reader";
import querySearch from "stringquery";

class TankAssignView extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedTank: props.selectedTank,
            lookupTank: null,
            canScan: true,
        };        
        this.handleFinaliseTankAssignment = this.handleFinaliseTankAssignment.bind(this);
        this.handleSetTankId = this.handleSetTankId.bind(this);
        this.handleLookupTank = this.handleLookupTank.bind(this);
        this.onScan = this.onScan.bind(this);
        this.onScanError = this.onScanError.bind(this);
        this.loadTankRequestById = this.loadTankRequestById.bind(this);
    }       

    handleLookupTank() {
        let {selectedTank} = this.state;

        this.setState({lookupTank: null}, ()=> {
            apiRequest(`/api/tanks/?id=${selectedTank.tankId}`)
                .then(x => {
                    if (x.data && x.data.notFound === true) {
                        toastr.error(`Tank #${selectedTank.tankId} information NOT found`);
                        this.setState({lookupTank: null, canScan: true});
                    } else {
                        this.setState({lookupTank: x.data, canScan: true});
                    }
                });
        });
    }

    handleFinaliseTankAssignment() {
        let {selectedTank} = this.state;
        let {onTankAssigned} = this.props;
        
        onTankAssigned(selectedTank);
    }

    handleSetTankId(e) {
        let tankId = parseInt(e.target.value);
        let {selectedTank} = this.state;

        if (tankId > 0) {
            this.setState({selectedTank: {...selectedTank, tankId}, lookupTank: null});
        } else {
            this.setState({selectedTank: {...selectedTank, tankId: null}, lookupTank: null});
        }
    }


    onScan(data) {
        let {selectedTank, canScan} = this.state;

        if (data && canScan) {
            if (data.includes('?')) {
                let split = data.split('?');
                let query = querySearch(`?${split[1]}`);

                if(selectedTank.tankId !== query.tankId) {
                    this.setState({
                        selectedTank: {...selectedTank, tankId: query.tankId},
                        lookupTank: null,
                        canScan: false
                    }, () => {
                        this.handleLookupTank();
                    });
                }

            } else {
                this.setState({scanResult: data, canScan: true, status: 'Scan does not contain a tankId'});
            }
        }
    }

    onScanError(data){
        console.log(data);
    }
    
    loadTankRequestById(){
        let {tankRequestId} = this.props;
        if (!IsNullOrUndefined(tankRequestId)) {
            apiRequest(`/api/tanks/tankRequest/${tankRequestId}`)
                .then(x => {
                    if (x.data && x.data.notFound === true) {
                        toastr.error(`Tank Request information NOT found`);
                        this.setState({selectedTank: null, lookupTank: null});
                    } else {
                        this.setState({selectedTank: x.data, lookupTank: null});
                    }
                });
        }
    }
    
    componentDidMount() {        
        this.loadTankRequestById();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {        
        if (!IsNullOrUndefined(this.props.selectedTank) && IsNullOrUndefined(this.state.selectedTank)) {
            this.setState({selectedTank: this.props.selectedTank});
        } else if (IsNullOrUndefined(this.props.tankRequestId) && IsNullOrUndefined(this.props.selectedTank) && !IsNullOrUndefined(this.state.selectedTank)) {
            this.setState({selectedTank: null});
        } else if ((!IsNullOrUndefined(this.props.selectedTank) && !IsNullOrUndefined(this.state.selectedTank)) && this.props.selectedTank.id !== this.state.selectedTank.id) {
            this.setState({selectedTank: this.props.selectedTank});
        } else if(this.props.tankRequestId !== prevProps.tankRequestId){
            this.loadTankRequestById();
        }
    }

    render() {
        let {isModalOpen, selectedTank, lookupTank} = this.state;
        let {baseLocationIds, onCancel, basicMatch} = this.props;
        
        if(IsNullOrUndefined(selectedTank)){
            return null;
        }
        
        // Get a list of tanks to be exchanged, driver must scan (enter tank Id) for each, this becomes the assignment        

        let basic = !IsNullOrUndefined(lookupTank) 
            && selectedTank.tankSizeId === lookupTank.tankSizeId
            && selectedTank.tankRequestHasHeater === lookupTank.hasHeater
            && lookupTank.currentTankLocationIsBase;
        
        let canAssign = basicMatch ? basic : basic && baseLocationIds.length > 0 &&
            (some(baseLocationIds, x => x === lookupTank.currentTankLocationId)) 
            && lookupTank.isConsideredPending === false
            && lookupTank.isInactive === false;

        return (
            <Aux>                

                <Modal isOpen={!IsNullOrUndefined(selectedTank)} toggle={onCancel}>
                    <ModalBody>
                        <Form onSubmit={e => {
                            e.preventDefault();
                            if(lookupTank && canAssign){
                                this.handleFinaliseTankAssignment()
                            } else {
                                this.handleLookupTank();
                            }
                        }}>
                            {selectedTank &&
                            <Aux>
                                <div className={"row"}>
                                    <div className={"col-12"}><h5>Lookup Tank</h5></div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-3"}>Tank</div>
                                    <div className={"col-9"}>{selectedTank.tankName}</div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-3"}>Heater</div>
                                    <div className={"col-9"}>{selectedTank.tankRequestHasHeater ? "Requires heater" : "Not required"}</div>
                                </div>
                            </Aux>
                            }

                            <FormGroup>
                                <Label for="tankId">Tank #</Label>
                                <Input type="number"
                                       name="tankId"
                                       id="tankId"
                                       value={IsNullOrUndefined(selectedTank) || IsNullOrUndefined(selectedTank.tankId) ? '' : selectedTank.tankId}
                                       onChange={this.handleSetTankId}
                                />
                            </FormGroup>

                            <div className={"row"}>
                                <div className={"col-12"}>
                                    <QrReader
                                        delay={300}
                                        onError={this.onScanError}
                                        onScan={this.onScan}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>



                        </Form>

                        {lookupTank &&
                        <Aux>
                            <div className={"row mt-2"}>
                                <div className={"col-12"}><h5>Found Tank {lookupTank.idWithPrefix}</h5></div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-3"}>Tank</div>
                                <div className={"col-9"}>{lookupTank.formattedName}</div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-3"}>Location</div>
                                <div className={"col-9"}>{lookupTank.currentTankLocationName}</div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-3"}>Status</div>
                                <div className={"col-9"}>{lookupTank.tankStatusTypeString}</div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-3"}>Heater</div>
                                <div className={"col-9"}>{lookupTank.hasHeater ? "Yes" : "No"}</div>
                            </div>

                            {!canAssign && <div className={"row text-warning"}>
                                <div className={"col-12"}>The looked up tank is not at the base or drop off
                                    location or it is of the wrong type or status
                                </div>
                            </div>}
                        </Aux>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <FormGroup>
                            {IsNullOrUndefined(lookupTank) && <Button color="info"
                                                                      className={"mr-1"}
                                                                      onClick={this.handleLookupTank}>Lookup
                                Tank</Button>}

                            {canAssign && <Button color="success"
                                                  className={"mr-1"}
                                                  onClick={this.handleFinaliseTankAssignment}>Assign
                                Tank</Button>}
                            <Button onClick={onCancel}>Cancel</Button>
                        </FormGroup>
                    </ModalFooter>
                </Modal>
            </Aux>);
    }
}

TankAssignView.propTypes = {
    onTankAssigned: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    selectedTank: PropTypes.object,    
    baseLocationIds: PropTypes.array.isRequired,
    tankRequestId: PropTypes.number,
    basicMatch: PropTypes.bool.isRequired,
};

export default TankAssignView;